import { render, staticRenderFns } from "./cardMethod.vue?vue&type=template&id=221a494e&scoped=true&"
import script from "./cardMethod.vue?vue&type=script&lang=js&"
export * from "./cardMethod.vue?vue&type=script&lang=js&"
import style0 from "./cardMethod.vue?vue&type=style&index=0&id=221a494e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a494e",
  null
  
)

component.options.__file = "cardMethod.vue"
export default component.exports